/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { JSX } from 'react';

import { StyledText } from './styledComponents';

import { ENUM_COLORS } from './textEnums';

import theme from '../../theme';

const getThemeFonts = (theme: any) => ({
  H1: theme.fonts.h1,
  H1_INTER: theme.fonts.h1Inter,
  TEXT_MIDDLE_NORMAL: theme.fonts.textMiddleNormal,
  TEXT_SMALL: theme.fonts.textSmall,
  TEXT_SMALL_HEIGHT_24: theme.fonts.textSmallHeight24,
  TEXT_SMALL_HEIGHT_16: theme.fonts.textSmallHeight16
});

const getThemeColors = (theme: any) => ({
  LIGHTEST: theme.colors.greys.lightest,
  IP_BLACK_1: theme.colors.blacks.ipBlack1,
  IP_BLACK_4: theme.colors.blacks.ipBlack4,
  IP_BLACK_5: theme.colors.blacks.ipBlack5,
  ERROR: theme.colors.red.error
});

const Text = ({
  style,
  color,
  font,
  fontWeight,
  fontSize,
  fontLineHeight,
  children
}: {
  style: React.CSSProperties;
  color: string;
  font: string;
  fontWeight: string;
  fontSize: string;
  fontLineHeight: string;
  children: JSX.Element | JSX.Element[] | string;
}) => {
  const getColor = () => {
    const colors: any = getThemeColors(theme);

    if (colors[color as keyof typeof colors]) {
      return colors[color as keyof typeof colors];
    }

    if (color && color.includes('#')) {
      return color;
    }

    return colors.DARKEST;
  };

  const getFont = () => {
    const fonts: object = getThemeFonts(theme);

    return (
      fonts[font as keyof typeof fonts] ||
      `normal ${fontWeight} ${fontSize}px/${fontLineHeight}px inter`
    );
  };

  return (
    <StyledText color={getColor()} font={getFont()} style={style}>
      {children}
    </StyledText>
  );
};

Text.defaultProps = {
  style: {},
  fontSize: 14,
  fontWeight: 500,
  fontLineHeight: 16,
  color: ENUM_COLORS.IP_BLACK_4
};

export default Text;
